import { render } from "./HospitalAdmissionForm.vue?vue&type=template&id=0181b517&ts=true"
import script from "./HospitalAdmissionForm.ts?vue&type=script&lang=ts&external"
export * from "./HospitalAdmissionForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__